export default {
  app:{
  provider: 'Proveedores',
  searchGames: 'Buscar Juegos...',
  username: 'Usuario',
  },
    nav: {
      home: 'Inicio',
      games: 'Juegos',
      profile: 'Perfil'
    },
    auth: {
      login: 'Iniciar Sesión',
      logout: 'Cerrar Sesión',
      register: 'Registrarse',
      usernamePlaceholder: 'USUARIO',
      passwordPlaceholder: 'CONTRASEÑA',
      togglePassword: 'Mostrar/Ocultar contraseña',
      forgotPassword: 'Olvidé mi contraseña',
      namePlaceholder: 'Nombre completo',
      emailPlaceholder: 'Correo electrónico',
      confirmPasswordPlaceholder: 'Confirmar contraseña',
      acceptTerms: 'Acepto los términos y condiciones',
      alreadyHaveAccount: 'Tienes cuenta? Inicia sesión',
      affiliateCodePlaceholder: 'Código de afiliado (opcional)',
      affiliateCode: 'Código de Afiliado',
      adultConfirmation: 'Soy Mayor de Edad',
      registrationSuccessful: '¡Registro exitoso! Ahora puedes iniciar sesión con tus credenciales.',
      errors: {
        emptyUsername: 'El campo usuario no puede estar vacío',
        emptyPassword: 'El campo contraseña no puede estar vacío',
        user_not_found: 'Usuario no encontrado',
        active_session: 'Sesión activa',
        invalid_password: 'Contraseña inválida',
        account_banned: 'Cuenta bloqueada',
        invalid_credentials: 'Credenciales inválidas',
        logout_success: 'Sesión cerrada',
        connectionError: 'Error de conexión',
        serverError: 'Error del servidor, intente más tarde',
        //resgitration error:
    emptyName: 'El nombre completo es obligatorio',
    emptyEmail: 'El correo electrónico es obligatorio',
    passwordMismatch: 'Las contraseñas no coinciden',
    termsRequired: 'Debes aceptar los términos y condiciones',
    registerFailed: 'Error al registrar la cuenta. Inténtalo de nuevo.',
    emailInvalid: 'Correo electrónico inválido',
    emailTaken: 'El correo electrónico ya está en uso',
    usernameTaken: 'El nombre de usuario ya está en uso',
    usernameInvalid: 'El nombre de usuario debe tener al menos 3 caracteres',
    passwordWeak: 'La contraseña debe tener al menos 8 caracteres',
    passwordInvalid: 'La contraseña debe tener al menos 8 caracteres',
    passwordRequired: 'La contraseña es obligatoria',
    usernameRequired: 'El nombre de usuario es obligatorio',
    emailRequired: 'El correo electrónico es obligatorio',
    loginRequired: 'Debes iniciar sesión para continuar',
    adultConfirmationRequired: 'Debes confirmar que eres mayor de 18 años',
    
      }
    },
    loading: {
    title: 'Cargando',
    resources: 'Recursos',
    credentials: 'Credenciales',
    games: 'Juegos',
    jackpots: 'Jackpots',
    balances: 'Balances'
  }, 
  account: {
    title: 'Cuenta',
    balance: 'Balance',
    credit: 'Crédito',
    bonus: 'Bono',
    terminal: 'Terminal',
    id: 'ID',
    logout: 'Salir'
  },
  pagination: {
    loadMoreGames : "cargar más juegos",
    noMoreGames : "No hay más juegos para cargar",
    show: "Mostrando",
    of : "de",
    games : "juegos",
  },
    "header": {
      "return_lobby": "Volver al Lobby"
    },
    "cashback": {
      "notify_bonus_message": "Ganaste Un Bono Cashback de:",
    },
  footer: {
    contactUs: 'Contáctanos', // Contate-nos
    followUs: 'Síguenos', // Siga-nos
    aboutUs: 'Sobre nosotros', // Sobre nós
    termsAndConditions: 'Términos y condiciones', // Termos e condições
    privacyPolicy: 'Política de privacidad', // Política de privacidade
    responsibleGaming: 'Juego responsable', // Jogo responsável
    affiliates: 'Afiliados', // Afiliados
    faq: 'Preguntas frecuentes', // Perguntas frequentes
    blog: 'Blog', // Blog
    mobileApp: 'Aplicación móvil', // Aplicativo móvel
    promotions: 'Promociones', // Promoções
    support: 'Soporte', // Suporte
    paymentMethods: 'Métodos de pago', // Métodos de pagamento
    gameProviders: 'Proveedores de juegos', // Fornecedores de jogos
    socialMedia: 'Redes sociales', // Mídias sociais
    allRightsReserved: 'Todos los derechos reservados', // Todos os direitos reservados
},
report: {
  tittle: 'Mis Reportes',
  user: 'Usuario',
  transactions: 'Transacciones',
  from: 'Desde',
  to: 'Hasta',
  type: 'Tipo',
  all: 'Todos',
  deposits: 'Depósitos',
  withdrawals: 'Retiros',
  total_deposits: 'Total de Depósitos',
  total_withdrawals: 'Total de Retiros',
  total_net: 'Balance Neto',
  date: 'Fecha',
  amount: 'Monto',
  description: 'Descripción',
  page: 'Página',
  of: 'de',
  previous: 'Anterior',
  next: 'Siguiente',
  loading_transactions: 'Cargando Transacciones...',
  no_transactions_found_for_this_period: 'No se encontraron transacciones para este período',
  games: 'Juegos',
  game: 'Juego',
  provider: 'Proveedor',
  total_bet: 'Total Apostado',
  total_win: 'Total Ganado',
  net_result: 'Ganancia Neta',
  average_rtp: 'RTP',
  no_game_data_found: 'No se encontraron datos de juegos',
  try_different_date_range: 'Prueba con un rango de fechas diferente',
  bonuses: 'Bonos',
  status: 'Estado',
  all_statuses: 'Todos',
  collected: 'Recibido',
  pending: 'Pendiente',
  cancelled: 'Cancelado',
  no_bonus_data_found: 'No se encontraron datos de bonos',
  parent_id:'ID del Padre',  
  player_id:'ID del Jugador',  
  balance_before:'Anterior', 
  balance_after:'Final', 
  bet_amount:'Apuesta',  
  won_loss:'Resultado',  
  bonus_type:'Bono',  
  game_name:'Juego',  
  bonus_active:'Activo',
  bonus_collected: 'Bono Cobrado',
  bonus_cancelled: 'Bono Cancelado',
  loading_game_history:'Cargando Historial de Juego',  
  bonus_by_status:'Bono por Estado',  
  total_cashback:'Total Cashback',  
  total_jackpot:'Total Jackpot',  
  total_bonus:'Total Bonos',  
  cashback_history:'Historial Cashback',  
  bonus_amount:'Monto Bono',  
  bonus_cashback: "Bono (Cashback)",
    bonus_pending: "Pendiente",
    bonus_jackpot: "Bono(Jackpot)",

  

},
"common": {
  "close": "CERRAR",
},

"errors": {
    "need_balance_to_launch": "Necesita saldo para jugar"
  },
  

  }